import React, { Component } from "react";
import * as common from "libs/commonFunc";
import { NavLink } from "react-router-dom";
import { injectIntl, defineMessages } from "react-intl";

import { Segment, Grid, Dropdown, Image, Button as SemanticButton } from "semantic-ui-react";
import { Tooltip } from "material-ui";

import { Button, ModalSendVaccine, ModalDownloadReport } from "components";

import styles from "./ExamHeader.css";
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

class ExamHeader extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    // 데이터
    const {
      isModal,
      examSummaryByExamNo,
      examSummaryOrdering,
      selectedExamSummaryNo,
      selectedExamList,
      examListTotalItem,
      currentPath,
      loadingVaccine,
      loadingReport,
      loadingReportMerge,
      loadingReportCsv,
    } = this.props;
    // function
    const { onExamRefresh, onDownloadExamReport, onDownloadExamReportMerge, onDownloadExamReportCsv, onActionVaccine, onToggleModal, toggleReportModal } = this.props;

    // let totalCount = 0;
    // const curData = examSummaryByExamNo.toJS();
    // const curArray = examSummaryOrdering.toJS();
    // if (curData && curArray) {
    //   Object.keys(curData).filter(key => {
    //     if (key === curArray[0].toString()) {
    //       totalCount = curData[key].rnum
    //     }
    //   });
    // }

    const examData = examSummaryByExamNo.get(String(selectedExamSummaryNo));
    const isExamAll = selectedExamSummaryNo === "all";
    // 피싱 유도 템플릿
    const isPhishing = !!examData && 4 === examData.get("examType") ? true : false;
    // 모의 악성 템플릿 (치료 단계 여부)
    const isCure = !!examData && 1 === examData.get("examType") && 2 === examData.getIn(["attachData", "attachExamType"]) ? true : false;

    // 전체 훈련일경우 총 훈련 개수 개별 훈련은 기간
    const examPeriod = !!isExamAll
      ? defineMessages(formatMessage({ id: "ExamHeader_1", defaultMessage: "총" })) +
        " " +
        examSummaryByExamNo.size +
        // (totalCount ? totalCount : 0) +
        defineMessages(formatMessage({ id: "ExamHeader_2", defaultMessage: "개의" })) +
        " " +
        defineMessages(formatMessage({ id: "ExamHeader_3", defaultMessage: "훈련" }))
      : !!examData
      ? "(" + common.timeFormatFromUTCEpoch(examData.get("examStartEpoch"), 3) + " ~ " + common.timeFormatFromUTCEpoch(examData.get("examEndEpoch"), 3) + ")"
      : "";

    let VaccineItem = (
      <Dropdown.Item onClick={() => onToggleModal("sendVaccine")}>
        <div className={cx("item-report")}>{defineMessages(formatMessage({ id: "ExamHeader_29", defaultMessage: "훈련 대상에게 백신 메일 발송" }))}</div>
      </Dropdown.Item>
    );

    if (selectedExamSummaryNo === "all") {
      VaccineItem = (
        <Dropdown.Item>
          <Tooltip
            title={defineMessages(formatMessage({ id: "ExamHeader_30", defaultMessage: "'전체 훈련'이 아닌 '개별 훈련'을 선택하세요" }))}
            classes={{ tooltip: "tooltip-noMaxWidth" }}
            placement="bottom"
          >
            <div className={cx("item-report disabled")}>{defineMessages(formatMessage({ id: "ExamHeader_29", defaultMessage: "훈련 대상에게 백신 메일 발송" }))}</div>
          </Tooltip>
        </Dropdown.Item>
      );
    } else if (currentPath === "/main/exam/pi" && examListTotalItem === 0) {
      VaccineItem = (
        <Dropdown.Item>
          <Tooltip title={defineMessages(formatMessage({ id: "ExamHeader_34", defaultMessage: "발송 대상자가 없습니다." }))} classes={{ tooltip: "tooltip-noMaxWidth" }} placement="bottom">
            <div className={cx("item-report disabled")}>{defineMessages(formatMessage({ id: "ExamHeader_29", defaultMessage: "훈련 대상에게 백신 메일 발송" }))}</div>
          </Tooltip>
        </Dropdown.Item>
      );
    }
    const VaccineDownload = (
      <Dropdown className={cx("bt-vaccine")} button floating labeled text={defineMessages(formatMessage({ id: "ExamHeader_26", defaultMessage: "백신" }))}>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => onActionVaccine("down")}>
            <div className={cx("item-report")}>{defineMessages(formatMessage({ id: "ExamHeader_28", defaultMessage: "백신 다운로드" }))}</div>
          </Dropdown.Item>
          {!!isCure ? VaccineItem : ""}
          {!!isCure ? (
            <Dropdown.Item onClick={() => onToggleModal("infectionVaccine")}>
              <div className={cx("item-report")}>{defineMessages(formatMessage({ id: "ExamHeader_36", defaultMessage: "감염 대상에게 백신 메일 발송" }))}</div>
            </Dropdown.Item>
          ) : (
            ""
          )}
        </Dropdown.Menu>
      </Dropdown>
    );

    // // 통합 보고서 다운로드
    // let MergeReportDownload = (
    //   <Tooltip
    //     title={defineMessages(
    //       formatMessage({
    //         id: 'ExamHeader_32',
    //         defaultMessage: "2개 이상의 '그룹 훈련'을 선택하세요"
    //       })
    //     )}
    //     classes={{ tooltip: 'tooltip-noMaxWidth' }}
    //     placement="bottom">
    //     <div className={cx('item-report disabled')}>
    //       {defineMessages(
    //         formatMessage({
    //           id: 'ExamHeader_24',
    //           defaultMessage: '통합 보고서'
    //         })
    //       )}
    //     </div>
    //   </Tooltip>
    // );
    // // 보고서 다운로드
    // let ReportDownload = (
    //   <Tooltip
    //     title={defineMessages(
    //       formatMessage({
    //         id: 'ExamHeader_11',
    //         defaultMessage: '훈련을 선택하세요'
    //       })
    //     )}
    //     classes={{ tooltip: 'tooltip-noMaxWidth' }}
    //     placement="bottom">
    //     <div className={cx('item-report disabled')}>
    //       {defineMessages(formatMessage({ id: 'ExamHeader_31', defaultMessage: '개별 보고서' }))}
    //     </div>
    //   </Tooltip>
    // );
    // let CsvReportDownload = (
    //   <Tooltip
    //     title={defineMessages(
    //       formatMessage({
    //         id: 'ExamHeader_11',
    //         defaultMessage: '훈련을 선택하세요'
    //       })
    //     )}
    //     classes={{ tooltip: 'tooltip-noMaxWidth' }}
    //     placement="bottom">
    //     <div className={cx('item-report disabled')}>
    //       {defineMessages(formatMessage({ id: 'ExamHeader_37', defaultMessage: 'CSV 보고서' }))}
    //     </div>
    //   </Tooltip>
    // )

    // // 훈련을 하나 선택
    // if (selectedExamSummaryNo !== 'all' || selectedExamList.size > 0) {
    //   // 통합 보고서 여부 체크
    //   const isValidExamNo = {};
    //   // 예약 훈련의 유무 체크
    //   let isReserve = false;

    //   // examSummary에서 훈련 선택
    //   if (selectedExamList.size === 0 && examSummaryByExamNo) {
    //     const selectedData = examSummaryByExamNo.get(String(selectedExamSummaryNo));

    //     if (selectedData && selectedData.get('examStartEpoch') > common.nowEpoch()) {
    //       isReserve = true;
    //     } else {
    //       //
    //     }
    //   }

    //   // 전체 훈련 내에서 훈련 선택
    //   for (let i = 0, l = selectedExamList.size; i < l; i++) {
    //     const ed = examSummaryByExamNo.get(String(selectedExamList.get(i)));

    //     if (!!ed) {
    //       if (ed.get('examStartEpoch') > common.nowEpoch()) {
    //         isReserve = true;
    //         break;
    //       }

    //       const pNo = ed.get('parentsExamNo');
    //       if (pNo) {
    //         if (typeof isValidExamNo[pNo] === 'undefined') {
    //           isValidExamNo[pNo] = 0;
    //         }

    //         isValidExamNo[pNo] += 1;
    //       } else {
    //         break;
    //       }
    //     } else {
    //       break;
    //     }
    //   }

    // ReportDownload = (
    //   <Tooltip
    //     title={
    //       isReserve
    //         ? defineMessages(
    //           formatMessage({
    //             id: 'ExamHeader_22',
    //             defaultMessage: '예약 훈련은 보고서를 생성 할 수 없습니다.'
    //           })
    //         )
    //         : defineMessages(
    //           formatMessage({ id: 'ExamHeader_10', defaultMessage: "훈련 결과 '보고서'를 엑셀 파일로 다운로드" })
    //         )
    //     }
    //     classes={{ tooltip: 'tooltip-noMaxWidth' }}
    //     placement="bottom">
    //     {isReserve ? (
    //       <div className={cx('item-report disabled')}>
    //         {defineMessages(formatMessage({ id: 'ExamHeader_31', defaultMessage: '개별 보고서' }))}
    //       </div>
    //     ) : (
    //         <Button
    //           className={cx('item-report')}
    //           loading={loadingReport}
    //           disabled={isReserve || loadingReport ? true : false}
    //           onClick={onDownloadExamReport}>
    //           {defineMessages(formatMessage({ id: 'ExamHeader_31', defaultMessage: '개별 보고서' }))}
    //         </Button>
    //       )}
    //   </Tooltip>
    // );

    // CsvReportDownload = (
    //   <Tooltip
    //     title={
    //       isReserve
    //         ? defineMessages(
    //           formatMessage({
    //             id: 'ExamHeader_22',
    //             defaultMessage: '예약 훈련은 보고서를 생성 할 수 없습니다.'
    //           })
    //         )
    //         : defineMessages(
    //           formatMessage({ id: 'ExamHeader_10', defaultMessage: "훈련 결과 '보고서'를 엑셀 파일로 다운로드" })
    //         )
    //     }
    //     classes={{ tooltip: 'tooltip-noMaxWidth' }}
    //     placement="bottom">
    //     {isReserve ? (
    //       <div className={cx('item-report disabled')}>
    //         {defineMessages(formatMessage({ id: 'ExamHeader_37', defaultMessage: 'CSV 보고서' }))}
    //       </div>
    //     ) : (
    //         <Button
    //           className={cx('item-report')}
    //           loading={loadingReportCsv}
    //           disabled={isReserve || loadingReportCsv ? true : false}
    //           onClick={onDownloadExamReportCsv}>
    //           {defineMessages(formatMessage({ id: 'ExamHeader_37', defaultMessage: 'CSV 보고서' }))}
    //         </Button>
    //       )}
    //   </Tooltip>
    // );

    //   if (selectedExamSummaryNo === 'all' && selectedExamList.size > 1) {
    //     if (
    //       isValidExamNo &&
    //       // 한개의 parentsExamNo만 있어야 한다.
    //       Object.keys(isValidExamNo).length === 1 &&
    //       // 모든 parentsExamNo의 개수가 선택한 훈련의 수와 같아야 한다.
    //       isValidExamNo[Object.keys(isValidExamNo)[0]] === selectedExamList.size
    //     ) {
    //       MergeReportDownload = (
    //         <Tooltip
    //           title={
    //             isReserve
    //               ? defineMessages(
    //                 formatMessage({
    //                   id: 'ExamHeader_22',
    //                   defaultMessage: '예약 훈련은 보고서를 생성 할 수 없습니다.'
    //                 })
    //               )
    //               : defineMessages(
    //                 formatMessage({
    //                   id: 'ExamHeader_23',
    //                   defaultMessage: '"통합 훈련 보고서" 다운로드 (묶음 훈련만 통합이 가능합니다.)'
    //                 })
    //               )
    //           }
    //           classes={{ tooltip: 'tooltip-noMaxWidth' }}
    //           placement="bottom">
    //           <Button
    //             className={cx('item-report')}
    //             loading={loadingReportMerge}
    //             disabled={isReserve || loadingReportMerge ? true : false}
    //             onClick={onDownloadExamReportMerge}>
    //             {defineMessages(
    //               formatMessage({
    //                 id: 'ExamHeader_24',
    //                 defaultMessage: '통합 보고서'
    //               })
    //             )}
    //           </Button>
    //         </Tooltip>
    //       );
    //     }
    //   }
    // }

    let isReserve = false;
    if (selectedExamSummaryNo === "all") {
      if (selectedExamList.size > 0) {
        selectedExamList.toJS().map((examNo) => {
          const examData = examSummaryByExamNo && examSummaryByExamNo.get(String(examNo));
          if (examData && examData.get("examStartEpoch") > common.nowEpoch()) {
            isReserve = true;
          }
        });
      }
    } else {
      const examData = examSummaryByExamNo && examSummaryByExamNo.get(String(selectedExamSummaryNo));
      if (examData && examData.get("examStartEpoch") > common.nowEpoch()) {
        isReserve = true;
      }
    }

    const Report = (
      <div className={cx("bt-report-wrap")}>
        {/* <Dropdown
          className={cx('bt-report')}
          button
          floating
          labeled
          icon={null}
          text={defineMessages(formatMessage({ id: 'ExamHeader_12', defaultMessage: '보고서' }))}>
          <Dropdown.Menu>
            <Dropdown.Item>{ReportDownload}</Dropdown.Item>
            <Dropdown.Item>{MergeReportDownload}</Dropdown.Item>
            <Dropdown.Item>{CsvReportDownload}</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}
        <Tooltip
          title={
            isReserve
              ? defineMessages(formatMessage({ id: "ExamHeader_22", defaultMessage: "예약 훈련은 보고서를 생성 할 수 없습니다." }))
              : selectedExamSummaryNo === "all" && selectedExamList.size < 1
              ? defineMessages(formatMessage({ id: "ExamHeader_11", defaultMessage: "훈련을 선택하세요" }))
              : ""
          }
          classes={{ tooltip: "tooltip-noMaxWidth" }}
          placement="bottom-start"
        >
          <div>
            <Button
              className={cx("bt-report")}
              // loading={loadingReport}
              // disabled={isReserve || loadingReport ? true : false}
              disabled={isReserve || (selectedExamSummaryNo === "all" && selectedExamList.size < 1)}
              buttonColor="transparent"
              onClick={() => onToggleModal("downloadReport")}
            >
              <span className="report-text">{defineMessages(formatMessage({ id: "ExamHeader_12", defaultMessage: "보고서" }))}</span>
            </Button>
            <Image src="/img/exam/menu_down.png" />
          </div>
        </Tooltip>
      </div>
    );

    let SendTitle = "";
    if (!!examData) {
      SendTitle = defineMessages(formatMessage({ id: "ExamHeader_6", defaultMessage: "발송" })) + ": " + examData.get("send");

      if (!!examData.get("sendError")) {
        SendTitle += " / " + defineMessages(formatMessage({ id: "ExamDetailTag_48", defaultMessage: "실패" })) + ": " + examData.get("sendError");
      }

      if (examData.get("isSuspend") === 1) {
        SendTitle = "(" + defineMessages(formatMessage({ id: "ExamSummaryItem_16", defaultMessage: "메일 발송 일시정지" })) + ") " + SendTitle;
      }

      if (examData.get("send") + examData.get("sendError") < examData.get("target")) {
        SendTitle +=
          " (" +
          defineMessages(formatMessage({ id: "ExamHeader_21", defaultMessage: "진행중" })) +
          ": " +
          (((examData.get("send") + examData.get("sendError")) / examData.get("target")) * 100).toFixed(0) +
          "%)";
      }
    }

    return (
      <div className={cx("examHeader-wrapper")}>
        {isModal === "sendVaccine" && <ModalSendVaccine visible isClicked={loadingVaccine} infection={false} onActionVaccine={onActionVaccine} onToggleModal={onToggleModal} />}
        {isModal === "infectionVaccine" && <ModalSendVaccine visible isClicked={loadingVaccine} infection={true} onActionVaccine={onActionVaccine} onToggleModal={onToggleModal} />}
        {isModal === "downloadReport" && (
          <ModalDownloadReport
            visible
            // isClicked={loadingReport}
            // onActionVaccine={onActionVaccine}
            onToggleModal={onToggleModal}
          />
        )}
        <div className={cx("title-area")}>
          <div className={cx("exam-title")}>
            {!!isExamAll ? (
              <div className={cx("exam-name")}>
                <div className={cx("ellipsis")}>{defineMessages(formatMessage({ id: "ExamHeader_4", defaultMessage: "전체 훈련" }))}</div>
              </div>
            ) : (
              <Tooltip title={!!examData && examData.get("examName")} placement="bottom-start">
                <div className={cx("exam-name")}>
                  <div className={cx("ellipsis")}>{!!examData && examData.get("examName")}</div>
                </div>
              </Tooltip>
            )}
          </div>
          <div className={cx("exam-date")}>{examPeriod}</div>
        </div>
        <div className={cx("header-right-area")}>
          <div className={cx("button-area")}>
            {/* 새로고침 버튼 */}
            <Tooltip title={defineMessages(formatMessage({ id: "ExamHeader_9", defaultMessage: "새로 고침" }))} classes={{ tooltip: "tooltip-noMaxWidth" }} placement="bottom">
              <div className={cx("refresh")} onClick={onExamRefresh}>
                <Image src="/img/exam/menu_refresh.png" />
              </div>
            </Tooltip>
            {/* 백신 다운로드 */}
            {VaccineDownload}
            {/* 보고서 다운로드 */}
            {Report}
          </div>
          <div className={cx("link-area")}>
            {!!isExamAll && (
              <Tooltip
                title={defineMessages(
                  formatMessage({
                    id: "ExamHeader_13",
                    defaultMessage: "훈련 결과를 '훈련'별로 보여줍니다.",
                  })
                )}
                classes={{ tooltip: "tooltip-noMaxWidth" }}
                placement="bottom"
              >
                <NavLink
                  exact
                  to="/main/exam/pi"
                  className={cx("examSubtab-item item-exam", {
                    selected: currentPath === "/main/exam/pi" || currentPath === "/main/exam/tag",
                  })}
                >
                  <span className={cx("link-text")}>{defineMessages(formatMessage({ id: "ExamHeader_33", defaultMessage: "훈 련" }))}</span>
                </NavLink>
              </Tooltip>
            )}
            {!isExamAll && (
              <Tooltip
                title={defineMessages(
                  formatMessage({
                    id: "ExamHeader_14",
                    defaultMessage: "훈련 결과를 '대상자'별로 보여줍니다.",
                  })
                )}
                classes={{ tooltip: "tooltip-noMaxWidth" }}
                placement="bottom"
              >
                <NavLink exact to="/main/exam/pi" className={cx("examSubtab-item  item-target", { selected: currentPath === "/main/exam/pi" })}>
                  <span className={cx("link-text")}>{defineMessages(formatMessage({ id: "ExamHeader_5", defaultMessage: "대 상" }))}</span>
                </NavLink>
              </Tooltip>
            )}
            {!isExamAll && (
              <Tooltip
                title={defineMessages(
                  formatMessage({
                    id: "ExamHeader_15",
                    defaultMessage: "훈련 결과를 '태그'별로 보여줍니다.",
                  })
                )}
                classes={{ tooltip: "tooltip-noMaxWidth" }}
                placement="bottom"
              >
                <NavLink exact to="/main/exam/tag" className={cx("examSubtab-item item-tag", { selected: currentPath === "/main/exam/tag" })}>
                  <span className={cx("link-text")}>{defineMessages(formatMessage({ id: "ExamHeader_17", defaultMessage: "태 그" }))}</span>
                </NavLink>
              </Tooltip>
            )}
            {!isPhishing && (
              <Tooltip
                title={defineMessages(
                  formatMessage({
                    id: "ExamHeader_16",
                    defaultMessage: "훈련 결과별 '감염 가능한 PC' 목록을 보여줍니다.",
                  })
                )}
                classes={{ tooltip: "tooltip-noMaxWidth" }}
                placement="bottom"
              >
                <NavLink exact to="/main/exam/infectionpc" className={cx("examSubtab-item item-pc", { selected: currentPath === "/main/exam/infectionpc" })}>
                  <span className={cx("link-text")}>{defineMessages(formatMessage({ id: "ExamHeader_18", defaultMessage: "감염 PC" }))}</span>
                </NavLink>
              </Tooltip>
            )}
            {!isPhishing && (
              <Tooltip
                title={defineMessages(
                  formatMessage({
                    id: "ExamHeader_19",
                    defaultMessage: "훈련 결과별 '감염 가능한 파일' 목록을 보여줍니다.",
                  })
                )}
                classes={{ tooltip: "tooltip-noMaxWidth" }}
                placement="bottom"
              >
                <NavLink exact to="/main/exam/leakfile" className={cx("examSubtab-item item-file", { selected: currentPath === "/main/exam/leakfile" })}>
                  <span className={cx("link-text")}>{defineMessages(formatMessage({ id: "ExamHeader_20", defaultMessage: "감염 파일" }))}</span>
                </NavLink>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(ExamHeader);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamHeader.js